import * as Scrivito from "scrivito";
import blogObjIcon from "assets/images/blog_obj.svg";
import {
  metadataConfiguratorInitialContent,
  metadataConfiguratorPropertiesGroups,
  metadataEditingConfigAttributes,
  metadataValidations,
} from "objs/_metadataEditingConfig";
import {
  defaultPageEditingConfigAttributes,
  defaultPageInitialContent,
  defaultPageProperties,
  defaultPageValidations,
  defaultPropertiesGroups,
} from "objs/_defaultPageEditingConfig";

Scrivito.provideEditingConfig("WizardItem", {
  title: "WizardItem",
  thumbnail: blogObjIcon,
  attributes: {
    title: {
      title: "title",
    },
    subType: {
      title: "Sub type",
      values: [
        { value: "fireprotection", title: "Fire Protection" },
        {
          value: "roomcontrol",
          title: "Room Control",
        },
        { value: "roomcontrolwireless", title: "Room Control Wireless" },
        { value: "xcube", title: "X-Cube" },
        { value: "xfans", title: "X Fans" },
      ],
    },
    isProdReady: {
      title: "Is Prod env ready?",
      description: "If yes,it will be show on production environment",
    },
    // Tile overview
    tileTitle: {
      title: "Title at tile overview",
    },
    tileSubtitle: {
      title: "Sub title at tile overview",
    },
    tileDescription: {
      title: "Description at tile overview",
    },
    tileImage: {
      title: "Image at tile overview",
    },
    // WizardLeftSidebar
    menuTitle: {
      title: "Title at wizard left sidebar",
    },
    menuTitleImage: {
      title: "Title icon at wizard left sidebar",
    },
    menuSubtitle: {
      title: "Subtitle at wizard left sidebar",
    },
    menuStepTitles: {
      title: "Steps titles at wizard left sidebar",
    },
    // Intro page
    introTitle: {
      title: "Title at introduction page",
    },
    introSubtitle: {
      title: "Sub title at introduction page",
    },
    introText: {
      title: "Text at introduction page",
    },
    introMedia: {
      title: "Video or image at introduction page",
    },
    linkForMenuItem: {
      title: "Link to redirect to a special url",
      description:
        "If you set this link, when this widget will be used as a menu item, click on it will" +
        " lead to redirection not to a widget, but to this link.",
    },
    ...metadataEditingConfigAttributes,
    ...defaultPageEditingConfigAttributes,
  },
  properties: [
    "isProdReady",
    "subType",
    ...defaultPageProperties,
    "linkForMenuItem",
    "imageForProductsNavigation",
    "redirectToProjectConfigurator",
  ],
  propertiesGroups: [
    {
      title: "Tile overview settings",
      properties: ["tileTitle", "tileSubtitle", "tileDescription", "tileImage"],
    },
    {
      title: "Wizard menu settings",
      properties: [
        "menuTitle",
        "menuSubtitle",
        "menuTitleImage",
        "menuStepTitles",
      ],
    },
    {
      title: "Intro page settings",
      properties: ["introTitle", "introSubtitle", "introText", "introMedia"],
    },
    ...defaultPropertiesGroups,
    ...metadataConfiguratorPropertiesGroups,
  ],
  initialContent: {
    ...metadataConfiguratorInitialContent,
    ...defaultPageInitialContent,
    title: "Wizard",
    showConfiguratorNav: true,
    isProdReady: false,
  },
  validations: [
    ...defaultPageValidations,
    ...metadataValidations,
    [
      "menuStepTitles",
      (menuStepsArr) => {
        if (!menuStepsArr.length) {
          return {
            message:
              'Wizard left side bar menu must have at least one step ("Introduction" for example).',
            severity: "error",
          };
        }
      },
    ],
  ],
});
